"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var PORTAL_ID = 'portal';
var Portal = function (_a) {
    var children = _a.children;
    var _b = __read((0, react_2.useState)(null), 2), element = _b[0], setElement = _b[1];
    (0, react_2.useLayoutEffect)(function () {
        var portalElement = document.getElementById(PORTAL_ID);
        if (!portalElement) {
            var tempElement = document.createElement('div');
            tempElement.id = PORTAL_ID;
            document.body.appendChild(tempElement);
        }
        setElement(document.getElementById(PORTAL_ID));
        return function () {
            var selectedPortalElement = document.getElementById(PORTAL_ID);
            if (selectedPortalElement && selectedPortalElement.children.length === 1) {
                document.body.removeChild(selectedPortalElement);
            }
        };
    }, []);
    if (!element)
        return null;
    return react_dom_1.default.createPortal(children, element);
};
exports.default = Portal;
